var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet 1",
    clipPath: "url(#clip0_1690_12960)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0029 4.47089H2.69371C2.37771 4.47089 2.12229 4.21489 2.12229 3.89946C2.12229 3.58403 2.37771 3.32803 2.69371 3.32803H12.7349V1.18517C12.7349 0.8806 12.5983 0.5966 12.3606 0.406315C12.1217 0.214886 11.8126 0.145743 11.5177 0.212029L0.778286 2.62346C0.320571 2.72631 0 3.12689 0 3.5966V14.7983C0 15.348 0.447429 15.796 0.997143 15.796H15.0029C15.5526 15.796 16 15.3486 16 14.7983V5.46803C16 4.91831 15.5526 4.47089 15.0029 4.47089ZM13.2034 11.152C12.6691 11.152 12.2349 10.7172 12.2349 10.1829C12.2349 9.6486 12.6697 9.21374 13.2034 9.21374C13.7383 9.21374 14.1726 9.6486 14.1726 10.1829C14.1726 10.7172 13.7383 11.152 13.2034 11.152Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1690_12960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.6ce273581d93b94096539a9028107b5e.svg";
export { ForwardRef as ReactComponent };